$(document).ready(function()
{

    window.addEventListener("load", function()
    {
        if( window.cookieconsent ) 
        {
            window.cookieconsent.initialise({
                
                palette: {
                    popup: {
                        background: "#4b5771",
                        text: "#fff",
                        link: '#fff'
                    },
                    button: {
                        background: "#ffffff",
                        text: '#2256aa'
                    }
                },
                theme: "edgeless",
                content: {
                    message: "This website uses cookies to ensure you get the best experience.",
                    href: "/cookies-policy/",
                    dismiss: 'Allow',
                },
                dismissOnScroll: false
            });
        }
    });
});